const brandColor = '#303f9f';

const ValidSelect = (iserror) =>{
 return {
    control: (base, state) => ({
        ...base,
        boxShadow: iserror ? '0 0 0 1px red'  : state.isFocused ? '0 0 0 1px '+brandColor : 0,
        borderColor: iserror ? 'red' : state.isFocused ?  brandColor: base.borderColor,
        '&:hover': {
        borderColor: iserror ? 'red' : state.isFocused ? brandColor : base.borderColor,
        },
    })
  };
}

export {
  ValidSelect
};
